const getCookieDomain = (rootState) => rootState.config.service.common.authtkt.cookie_domain;

export default getCookieDomain;
